import { render, staticRenderFns } from "./BrandApp.vue?vue&type=template&id=4fae974e&scoped=true"
import script from "./BrandApp.vue?vue&type=script&lang=js"
export * from "./BrandApp.vue?vue&type=script&lang=js"
import style0 from "./BrandApp.vue?vue&type=style&index=0&id=4fae974e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae974e",
  null
  
)

export default component.exports